import { render, staticRenderFns } from "./card-content-loader.vue?vue&type=template&id=51a39ac8&"
import script from "./card-content-loader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./card-content-loader.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports